module.exports = __webpack_public_path__ + "media/chime.7ffc3cb0.wav";